type TObjectWithDateStrings = {
  dateCreated?: string | null
  dateModified?: string | null
  dateAccepted?: string | null
  dateReceived?: string | null
  dateClosed?: string | null
  dateEstimatedShipment?: string | null
  dateRequestedShipment?: string | null
}
type TObjectWithDates = {
  dateCreated?: Date
  dateModified?: Date
  dateAccepted?: Date
  dateReceived?: Date
  dateClosed?: Date
  dateEstimatedShipment?: Date
  dateRequestedShipment?: Date
}
export function serializeDates<T>(o: T & TObjectWithDateStrings): T & TObjectWithDates {
  const ret = { ...o }
  if (ret.dateCreated) {
    ;(ret as TObjectWithDates).dateCreated = new Date(ret.dateCreated)
  }
  if (ret.dateModified) {
    ;(ret as TObjectWithDates).dateModified = new Date(ret.dateModified)
  }
  if (ret.dateAccepted) {
    ;(ret as TObjectWithDates).dateAccepted = new Date(ret.dateAccepted)
  }
  if (ret.dateReceived) {
    ;(ret as TObjectWithDates).dateReceived = new Date(ret.dateReceived)
  }
  if (ret.dateClosed) {
    ;(ret as TObjectWithDates).dateClosed = new Date(ret.dateClosed)
  }
  if (ret.dateEstimatedShipment) {
    ;(ret as TObjectWithDates).dateEstimatedShipment = new Date(ret.dateEstimatedShipment)
  }
  if (ret.dateRequestedShipment) {
    ;(ret as TObjectWithDates).dateRequestedShipment = new Date(ret.dateRequestedShipment)
  }
  return ret as T & TObjectWithDates
}
